module.exports = __webpack_public_path__ + "img/tip.fa190ef2.png";